import Client from "../../Client";
import Exceptions from "../../Exceptions";
import { getCurrentMonth, setCurrentMonth, wait } from "../../misc/date";
import { getSummary1 } from "../../services/api/data/sameday/published";
import { Notifier } from "../conductor";

// import rawProvinceCoordinates from "../../misc/coordinates/provinces.txt";
import { readJSONFile } from "../../misc/file";
import { DynamicMap, Vector } from "../../services/map";

export default class SamedayDashboardController {
    constructor(options) {
        this.reference = {
            map: { ...getCurrentMonth(), level: "provinces", category: "domestic" },
            pie: { ...getCurrentMonth(), level: "provinces" },
            bar: { ...getCurrentMonth(), level: "provinces" },
        };

        this.notifiers = {
            loading: new Notifier(true),
            loaded: new Notifier(false),
            
            error: new Notifier(null),
            
            mapError: new Notifier(null),
            pieError: new Notifier(null),
            barError: new Notifier(null),

            mapRefresh: new Notifier(),
            mapLoading: new Notifier(false),
            
            pieLoading: new Notifier(false),

            barLoading: new Notifier(false),
        };

        const self = this;
        this.status = {
            get loading() { return self.notifiers.loading.get() },
            get error() { return self.notifiers.error.get() },

            get mapLoading() { return self.notifiers.mapLoading.get() },
            get pieLoading() { return self.notifiers.pieLoading.get() },
            get barLoading() { return self.notifiers.barLoading.get() },
        };

        this.data = {};

        this.initialize();
    }

    async initialize() {
        // Client.ensureSignedIn();
        if(this.isInitialized) return; this.isInitialized = true;


        // Load coordinates
        this.data.coords = {
            provinces: await readJSONFile("/coordinates/provinces.txt"),
            lgus: await readJSONFile("/coordinates/lgus.txt"),
        };

        this.mapController = new DynamicMap({ unitSize: 14, offset: new Vector(1252, 113) });
        await this.loadMapData(false);
        await this.loadPieData(false);
        await this.loadBarData(false);


        this.notifiers.loading.update(false);
    }

    async loadMapData(notifies = true) {
        const { mapLoading, mapError } = this.notifiers;
        
        if(notifies) {
            mapError.update(null, { silent: true });
            mapLoading.update(true);
        }

        try {
            const { map: { month, year, province } } = this.reference;
            this.data.map = await getSummary1({ month, year, province });
            
            if(!province) {
                this.mapController.transform.zoomFactor = 1;
                this.mapController.transform.offset = new Vector(1252, 113);
            } else {
                const { transform: { offset: [ x, y ], zoomFactor } } = this.data.coords.lgus[province];
                this.mapController.transform.offset = new Vector(Number(x), Number(y));
                this.mapController.transform.zoomFactor = Number(zoomFactor);
            }
        } catch(e) {
            console.error(e);
            const semantics = Exceptions.getARESemantics(e);
            if(notifies) mapError.update(semantics);
        }

        if(notifies) mapLoading.update(false);
    }

    setMapCategory(category) {
        this.reference.map.category = category;
        this.notifiers.mapRefresh.notify();
    }

    changeMapDate({ month, year }) {
        this.reference.map = { ...this.reference.map, month, year };
        setCurrentMonth({ month, year });
        this.loadMapData(true);
    }

    expandMapProvince(provinceId) {
        this.reference.map.province = provinceId;
        this.loadMapData(true);
    }

    undoMap() { this.expandMapProvince(undefined); }






    async loadPieData(notifies = true) {
        const { pieLoading, pieError } = this.notifiers;
        
        if(notifies) {
            pieError.update(null, { silent: true });
            pieLoading.update(true);
        }

        try {
            const { pie: { month, year } } = this.reference;
            this.data.pie = await getSummary1({ month, year });
            // this.data.pie = getDummySummary1();

            this.data.pie.children = this.data.pie.children.sort((a, b) => 
            (b.total?.all || 0) - (a.total?.all || 0));

        } catch(e) {
            console.error(e);
            const semantics = Exceptions.getARESemantics(e);
            if(notifies) pieError.update(semantics);
        }

        if(notifies) pieLoading.update(false);
    }

    changePieDate({ month, year }) {
        this.reference.pie = { ...this.reference.pie, month, year };
        setCurrentMonth({ month, year });
        this.loadPieData(true);
    }




    async loadBarData(notifies = true) {
        const { barLoading, barError } = this.notifiers;
        
        if(notifies) {
            barError.update(null, { silent: true });
            barLoading.update(true);
        }

        try {
            const { bar: { month, year } } = this.reference;
            this.data.bar = await getSummary1({ month, year });
            // this.data.bar = getDummySummary1();

        } catch(e) {
            console.error(e);
            const semantics = Exceptions.getARESemantics(e);
            if(notifies) barError.update(semantics);
        }

        if(notifies) barLoading.update(false);
    }

    changeBarDate({ month, year }) {
        this.reference.bar = { ...this.reference.bar, month, year };
        setCurrentMonth({ month, year });
        this.loadBarData(true);
    }
}



function getDummySummary1() {
    return {
        "month": 2,
        "year": 2022,
        "children": [
            {
                "id": "1",
                "name": "Northern Samar",
                "total": {
                    "domestic": 300,
                    "foreign": 600,
                    "all": 1200
                }
            },

            {
                "id": "6",
                "name": "Southern Leyte",
                "total": {
                    "domestic": 50,
                    "foreign": 40,
                    "all": 100
                }
            },
            {
                "id": "2",
                "name": "Samar",
                "total": {
                    "domestic": 500,
                    "foreign": 100,
                    "all": 1000
                }
            },
            {
                "id": "3",
                "name": "Eastern Samar",
                "total": {
                    "domestic": 350,
                    "foreign": 300,
                    "all": 700
                }
            },
            {
                "id": "4",
                "name": "Leyte",
                "total": null
            },
            {
                "id": "5",
                "name": "Biliran",
                "total": {
                    "domestic": 150,
                    "foreign": 150,
                    "all": 300
                }
            },
        ]
    };
}